import React from "react";

function SetCurrentModal({ entry, currentEntry, entityName, apiEndpoint, onClose, onSetCurrent }) {
  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Set as Current List</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <p>
              This will make <strong>{entry.title}</strong> the current {entityName} list.
            </p>
            {currentEntry && currentEntry.id !== entry.id && (
              <div className="alert alert-info">
                <i className="fas fa-info-circle me-1" />
                The current list <strong>{currentEntry.title}</strong> will no longer be marked as current.
              </div>
            )}
            <p className="text-muted">
              The current list is served when requesting the API endpoint <code>{apiEndpoint}</code>
            </p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={() => onSetCurrent(entry.id)}>
              <i className="fas fa-check me-1" />
              Set as Current
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SetCurrentModal;
